import {
  Box,
  CircularProgress,
  Grid2,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import useAccessibilityModalStore from "../store";
//import { Handlers } from "../api/handlers";
import {
  actionCont,
  flexRowCont,
} from "../../../../common/styles/manage-accessibility-action";
import { palettes } from "../../../../common/themes/palletes";
import { AppSwitch } from "../../../../common/components/app-switch";
import { Save } from "@mui/icons-material";
import { Handlers } from "../api/handlers";
import {
  useCreateAccessibility,
  useCreateGAAccessibility,
  useUpdateAccessibility,
  useUpdateGAAccessibility,
} from "../api/hooks";
import { useParams } from "react-router-dom";

interface IActions {
  role?: string;
}

export const Actions: React.FC<IActions> = ({ role }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("tablet"));
  const { enableAll } = useAccessibilityModalStore();
  const updateAccessibility = useUpdateAccessibility();
  const createAccessibility = useCreateAccessibility();

  const updateGAAccessibility = useUpdateGAAccessibility();
  const createGAAccessibility = useCreateGAAccessibility();

  const { userData } = useAccessibilityModalStore();
  const { handleSave } = new Handlers();
  const size = {
    mobile: isMobile ? 12 : 6,
  };

  type Modes = "client" | "bizbox";

  const { mode } = useParams<{ mode: Modes }>();

  const isInternal = mode === "bizbox";

  const areAllEnabled = () => {
    const { modules } = useAccessibilityModalStore.getState();
    return modules.every(
      (module) =>
        module.enable && module.privileges.every((priv) => priv.enable),
    );
  };

  const isLoading =
    createAccessibility.isPending ||
    updateAccessibility.isPending ||
    createGAAccessibility.isPending ||
    updateGAAccessibility.isPending;

  return (
    <Grid2 container sx={actionCont}>
      <Grid2 sx={actionCont.grid} size={size}>
        <img
          src={userData?.photoUrl || "/bizlogo.svg"}
          alt={(userData?.name || "U").charAt(0)}
          style={{
            borderRadius: "50%",
            width: "48px",
            height: "48px",
            objectFit: "cover",
          }}
        />

        <Box sx={actionCont.fieldCont}>
          <Typography variant="body1" fontWeight={500} color="primary.light">
            {userData?.name}
          </Typography>
          <Box
            sx={{
              ...flexRowCont,
              border: "0.5px solid",
              borderColor: palettes.$oldAppBg,
              backgroundColor: palettes.$oldAppBg,
              borderRadius: "8px",
              px: "5px",
              height: "28px",
              fontWeight: 400,
              fontSize: "10px",
              color: "text.secondary",
            }}
          >
            {role}
          </Box>
        </Box>
      </Grid2>

      {
        <Grid2
          size={size}
          sx={{
            ...actionCont.grid,
            justifyContent: "end",
          }}
        >
          <Box sx={flexRowCont}>
            <Typography color="primary.light" variant="body2">
              Full Access
            </Typography>
            <AppSwitch
              //disabled={!isSuperAdmin && !manageAccessPrivileges?.assign}
              id="main-switch"
              checked={areAllEnabled()}
              onChange={enableAll}
              sx={{ mt: "5px" }}
              onClick={(event) => event.stopPropagation()}
              disabled={isLoading}
            />
          </Box>

          <Tooltip title="Save Changes">
            <IconButton
              id="save-changes-button"
              disabled={isLoading}
              onClick={() => {
                if (isInternal) {
                  handleSave(createAccessibility, updateAccessibility);
                } else {
                  handleSave(createGAAccessibility, updateGAAccessibility);
                }
              }}
              sx={actionCont.saveButton}
            >
              {isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <Save />
              )}
            </IconButton>
          </Tooltip>
        </Grid2>
      }
    </Grid2>
  );
};
